import { combineReducers, configureStore } from "@reduxjs/toolkit";

import category from "./slices/category";
import job from "./slices/job";
import user from "./slices/user";
import invoice from "./slices/invoice";
import smsTemplate from "./slices/smsTemplate";
import message from "./slices/message";
import checklist from "./slices/checklist";
import dashboard from "./slices/dashboard";
import loggingReducer from "./slices/loggingSlice";
import { logAction } from "./slices/loggingSlice";
import task from "./slices/task";
import order from "./slices/order";

const reducer = combineReducers({
  category,
  job,
  user,
  invoice,
  smsTemplate,
  message,
  checklist,
  dashboard,
  logging: loggingReducer,
  task,
  order,
});

const actionLogAllowlist = [
  "jobs/updateJobProgressStatus",
  "jobs/addToJobLogs",
  "jobs/updateJobStatus",
  "messages/smsSent",
  "messages/smsScheduled",
  "messages/scheduledSmsSent",
  "messages/smsRescheduled",
  "messages/scheduleCancelled",
];

const loggingMiddleware = (storeAPI) => (next) => (action) => {
  if (typeof action === "function") {
    return next(action);
  }

  const result = next(action);

  const shouldLog = action?.type && typeof action.type === "string" && actionLogAllowlist.includes(action.type);

  if (shouldLog) {
    const state = storeAPI.getState();
    const job = state.jobs?.job;
    const details = {
      payload: action.payload,
      jobId: job?.JOB_ID,
      jobNumber: job?.JOB_NO,
      progressStatus: job?.PROGRESS_STATUS,
    };

    storeAPI.dispatch(logAction(action.type, details));
  }

  return result;
};

export default configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(loggingMiddleware),
});
